export default {"src":"/_next/static/media/logout.95ec6272.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};